<script>
	export default {
		name: 'OneWaySmsExecuter',
		methods: {
			oneWaySmsPost(body) {
				const self_ = this;
				
				self_.callFunction('smsFunction', 'post' , { body: body })
			}
		}
	}
</script>